<script>

import {Pie} from "vue-chartjs";

export default {
  components: {
    Pie,
  },
  props: {
    active_lightpoles: Number,
    active_outages: Number,
    failure_rate_current: String,
    all_outages_in_period: Number,
    failure_rate_in_period: String,
    start_formatted_date: String,
    end_formatted_date: String,
    outage_late: Number,
    outage_not_late: Number,
  },
  data() {
    return {
      chartData: {
        labels: [
          'Storingen minder dan 10 werkdagen te laat',
          'Storingen meer dan 10 werkdagen te laat'
        ],
        datasets: [
          {
            label: 'Aantal',
            backgroundColor: ['#2ab27b', '#d9534f'],
            data: [
              this.outage_not_late,
              this.outage_late,
            ]
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'right',
        }
      }
    }
  },

}

</script>

<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            KPI Doorlooptijden
          </v-card-title>
          <v-card-text>
            <Pie
                  id="outages-late-chart"
                  :options="{
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                      display: true,
                      position: 'right',
                    }
                  }"
                  :data="chartData"
                />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Actuele uitval
          </v-card-title>
          <v-card-text>
            {{ failure_rate_current }}%<br />
            Openstaande storingen <b>({{ active_outages }})</b> / aantal lichtmasten <b>({{ active_lightpoles }})</b>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-card-title>
            Uitval in periode
          </v-card-title>
          <v-card-text>
            {{ failure_rate_in_period }}%<br />
            Alle storingen van {{ start_formatted_date }} t/m {{ end_formatted_date }} <b>({{ all_outages_in_period }})</b> / aantal lichtmasten <b>({{ active_lightpoles }})</b>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped lang="scss">

</style>
